import React from "react";
import { ArrowRight } from "lucide-react";

const RECEIPT_ROWS = [
  {
    title: "Reading saved",
    detail: "Question, date, evidence, and chart state",
    statusClassName: "is-cyan",
  },
  {
    title: "Two-week window",
    detail: "Compare repeated themes against lived notes",
    statusClassName: "is-amber",
  },
  {
    title: "Receipts analysis",
    detail: "AI separates corroboration from hindsight",
    statusClassName: "",
  },
];

export const ReceiptsSection: React.FC = () => (
  <section className="landing-receipts landing-reveal-section">
    <div className="landing-receipts__copy">
      <span className="landing-section-kicker">Receipts don&apos;t lie</span>
      <h2>Turn interpretation into a record you can return to</h2>
      <p>
        Your readings should become a dated body of evidence, not disappear after the session.
        Save the question, the chart epoch, the interpretation, and the Observatory context together.
      </p>
      <div className="landing-actions">
        <button
          type="button"
          onClick={() => window.location.assign("/observatory")}
          className="landing-button landing-button--primary"
        >
          Enter the Observatory
          <ArrowRight />
        </button>
        <button
          type="button"
          onClick={() => window.location.assign("/portal")}
          className="landing-button landing-button--outline"
        >
          Open your archive
        </button>
      </div>
    </div>

    <div className="landing-receipts__ledger">
      <div className="landing-ledger-heading">
        <div>
          <span>Private reading ledger</span>
          <p>A chronological record of your own questions and outcomes.</p>
        </div>
        <small>Account-scoped</small>
      </div>
      {RECEIPT_ROWS.map((row, index) => (
        <div className="landing-ledger-row" key={row.title}>
          <b>0{index + 1}</b>
          <span>
            <strong>{row.title}</strong>
            <small>{row.detail}</small>
          </span>
          <i className={row.statusClassName} />
        </div>
      ))}
    </div>

    <div className="landing-receipts__principles">
      <article>
        <span>Chronology</span>
        <p>Read your history in order and reopen the exact interpretation whenever you need it.</p>
      </article>
      <article>
        <span>Reflection</span>
        <p>Add lived observations so the system can distinguish useful signal from storytelling.</p>
      </article>
      <article>
        <span>Receipts</span>
        <p>Review patterns with explicit evidence boundaries instead of invented certainty.</p>
      </article>
    </div>
  </section>
);
